import { render, staticRenderFns } from "./xhj.vue?vue&type=template&id=1d5e046e&scoped=true&"
var script = {}
import style0 from "./xhj.vue?vue&type=style&index=0&id=1d5e046e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5e046e",
  null
  
)

export default component.exports